import { PersistentHandler } from './description-handlers/PersistentHandler.js';
import { SelectableHandler } from './description-handlers/SelectableHandler.js';
/**
 * Manager to create, populate and update handlers for `Selectable` and `Persistant` instances.
 */
export class DescriptionManager {
    constructor(_viewer, _debug_layer) {
        this._viewer = _viewer;
        this._debug_layer = _debug_layer;
        this._descriptions = [];
        this._selectable_handlers = [];
        this._persistent_handlers = [];
    }
    define_selectable(type, config) {
        const descriptions = this._descriptions.filter(description => this.is_applicable(type, description.type));
        const handler = new SelectableHandler(type, this._viewer, this._debug_layer, config, descriptions);
        this._selectable_handlers.push(handler);
    }
    define_persistent(type, config) {
        const descriptions = this._descriptions.filter(description => this.is_applicable(type, description.type));
        const handler = new PersistentHandler(type, this._viewer, this._debug_layer, config, descriptions);
        this._persistent_handlers.push(handler);
    }
    describe(description) {
        this._descriptions.push(description);
        const existing_handlers = this.get_applicable_handlers(description.type);
        existing_handlers.forEach(handler => handler.add_description(description));
        this.update();
    }
    get_selectable_handlers() {
        return this._selectable_handlers;
    }
    get_persistent_handlers() {
        return this._persistent_handlers;
    }
    update() {
        this._selectable_handlers.forEach(handler => handler.update());
    }
    hide_selectables() {
        this._selectable_handlers.forEach(handler => handler.hide());
    }
    show_selectables() {
        this._selectable_handlers.forEach(handler => handler.show());
    }
    dispose() {
        this._selectable_handlers.forEach(handler => handler.dispose());
        this._persistent_handlers.forEach(handler => handler.dispose());
        this._selectable_handlers.length = 0;
        this._persistent_handlers.length = 0;
    }
    get_applicable_handlers(type) {
        return [
            ...this._selectable_handlers.filter(handler => this.is_applicable(type, handler.type)),
            ...this._persistent_handlers.filter(handler => this.is_applicable(type, handler.type))
        ];
    }
    is_applicable(a, b) {
        return a === b || a.prototype === b || a.prototype instanceof b;
    }
}
//# sourceMappingURL=DescriptionManager.js.map